module.exports = __webpack_public_path__ + "static/media/601Hou.3d1e97b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/601Hou.png
// module id = 1677
// module chunks = 0 1